import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Group, Rect } from 'react-konva';
import { mapStrokeWidth } from '@/utils/board/strokeUtils';
export function rectGroup({ el, showElementSelectionBorder, layerLocked, common, clipFunc: _clipFunc, isVisible = true, isPresentationMode = false, }) {
    var _a, _b, _c, _d, _e, _f, _g;
    const fill = ((_a = el.props) === null || _a === void 0 ? void 0 : _a.fill) || '#ffffff';
    const opacityValue = (_b = el.props) === null || _b === void 0 ? void 0 : _b.opacity;
    const opacity = typeof opacityValue === 'number' && !isNaN(opacityValue) ? opacityValue : 1;
    const strokeValue = (_c = el.props) === null || _c === void 0 ? void 0 : _c.stroke;
    const strokeWidthValue = (_d = el.props) === null || _d === void 0 ? void 0 : _d.strokeWidth;
    const stroke = typeof strokeValue === 'string' && strokeValue ? strokeValue : undefined;
    const logicalStrokeWidth = typeof strokeWidthValue === 'number' && !isNaN(strokeWidthValue) ? strokeWidthValue : 5;
    // Применяем маппинг для физического размера обводки
    const strokeWidth = mapStrokeWidth(logicalStrokeWidth);
    let strokeEnabled = false;
    if (isPresentationMode && el.isPresentationFrame) {
        strokeEnabled = false;
    }
    else {
        strokeEnabled =
            typeof ((_e = el.props) === null || _e === void 0 ? void 0 : _e.strokeEnabled) === 'boolean'
                ? el.props.strokeEnabled
                : stroke !== undefined && stroke !== null;
    }
    const w = ((_f = el.props) === null || _f === void 0 ? void 0 : _f.w) || 120;
    const h = ((_g = el.props) === null || _g === void 0 ? void 0 : _g.h) || 80;
    return (_jsxs(Group, Object.assign({}, common, { visible: isVisible, children: [_jsx(Rect, { width: w, height: h, fill: fill, stroke: strokeEnabled ? stroke : undefined, strokeWidth: strokeWidth, strokeScaleEnabled: true, shadowForStrokeEnabled: false, perfectDrawEnabled: false, opacity: opacity }), showElementSelectionBorder && (_jsx(Rect, { x: 0, y: 0, width: w, height: h, stroke: el.locked || layerLocked ? '#d33' : '#5eafffff', strokeWidth: 2, strokeScaleEnabled: false, listening: false, shadowForStrokeEnabled: false, perfectDrawEnabled: false }))] }), el.id));
}
